import React from "react";
import { Col, Table, Container } from "react-bootstrap";
import classes from "../../WebsiteManagement/websiteManagement.module.css";

const dash = (value) => (value != null && value !== "" ? value : "—");

const formatAmount = (amount) => {
  const n = Number(amount);
  if (!Number.isFinite(n) || n <= 0) return "—";
  return `INR ${n}`;
};

const HolidayBillingDetails = ({ booking }) => (
  <Container fluid style={{ marginTop: "5vh" }}>
    <Col lg={12} md={12} className={classes.Response2}>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Bill To</th>
            <th>Amount</th>
            <th>Reference</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{dash(booking?.name)}</td>
            <td>{formatAmount(booking?.amount)}</td>
            <td>{dash(booking?.bookingRef)}</td>
          </tr>
        </tbody>
      </Table>
    </Col>
  </Container>
);

export default HolidayBillingDetails;
